/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function ($) {

    // Use this variable to set up the common and page specific functions. If you
    // rename this variable, you will also need to rename the namespace below.
    var Sage = {
        // All pages
        'common': {
            init: function () {
                // JavaScript to be fired on all pages
                if ($('.single-services').length) {
                    $('#menu-item-96').removeClass('current_page_parent');
                }
                $('.fancybox').fancybox();
                $('.fancy a').fancybox();
                $('.navtog').click(function () {
                    $('nav').fadeToggle();
                    $(this).toggleClass('open');
                });
                $('.carousel').slick({
                    dots: false,
                    infinite: false,
                    speed: 300,
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    prevArrow: "<button class='slick-prev slick-arrow slick-disabled' aria-label='Previous' type='button' aria-disabled='true' style='display: inline-block;'>Previous Module</button>",
                    nextArrow: "<button class='slick-next slick-arrow' aria-label='Next' type='button' style='display: inline-block;' aria-disabled='false'>Next Module</button>",
                    responsive: [
                        {
                            breakpoint: 1024,
                            settings: {
                                slidesToShow: 3,
                                slidesToScroll: 1,
                                infinite: true,
                                dots: true
                            }
                        },
                        {
                            breakpoint: 768,
                            settings: "unslick"
                        },

                        // You can unslick at a given breakpoint now by adding:
                        // settings: "unslick"
                        // instead of a settings object
                    ]
                });
                $('.example .arrow').click(function () {
                    $(this).siblings('div').children('.secondary').toggleClass('open');
                });
                $('body').click(function () {
                    $('div.wpcf7-response-output').fadeOut();
                });
            },
            finalize: function () {
                // JavaScript to be fired on all pages, after page specific JS is fired

                if ($(window).width() > 767) {
                    $(window).load(function () {
                        $('.eh').each(function () {
                            var height = 0;
                            $(this).find('.eqheight').each(function () {
                                if ($(this).height() > height) {
                                    height = $(this).height();
                                }
                            });
                            $(this).find('.eqheight').each(function () {
                                $(this).height(height);
                            });
                        });
                    });
                }
                // var publication = document.querySelectorAll('.publication') || undefined;
                // var home = document.querySelectorAll('.publication--home') || undefined;
                // setTimeout( function() {
                //     if(publication.length !== 0) {
                //         for(var i=0; i < publication.length; i++ ) {
                //             var title = publication[i].querySelector('.publication__form-title');
                //             var formField;

                //             if(home.length > 0) {
                //                 formField = document.querySelector('.js-pub-hidden-field');
                //             } else {
                //                 formField = publication[i].querySelector('.js-pub-hidden-field');

                //             }
                //             formField.value = title.innerHTML.trim();
                //         }
                //     }
                // }, 3000);

            }
        },
        // Home page
        'home': {
            init: function () {
                // JavaScript to be fired on the home page
            },
            finalize: function () {
                // JavaScript to be fired on the home page, after the init JS
            }
        },
        // About us page, note the change from about-us to about_us.
        'about_us': {
            init: function () {
                // JavaScript to be fired on the about us page
            }
        }
    };

    // The routing fires all common scripts, followed by the page specific scripts.
    // Add additional events for more control over timing e.g. a finalize event
    var UTIL = {
        fire: function (func, funcname, args) {
            var fire;
            var namespace = Sage;
            funcname = (funcname === undefined) ? 'init' : funcname;
            fire = func !== '';
            fire = fire && namespace[func];
            fire = fire && typeof namespace[func][funcname] === 'function';

            if (fire) {
                namespace[func][funcname](args);
            }
        },
        loadEvents: function () {
            // Fire common init JS
            UTIL.fire('common');

            // Fire page-specific init JS, and then finalize JS
            $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
                UTIL.fire(classnm);
                UTIL.fire(classnm, 'finalize');
            });

            // Fire common finalize JS
            UTIL.fire('common', 'finalize');
        }
    };

    // Load Events
    $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
